/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_No_OptionsInputs */

const en_general_no_options = /** @type {(inputs: General_No_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No options`)
};

const de_general_no_options = /** @type {(inputs: General_No_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Optionen`)
};

/**
* | output |
* | --- |
* | "No options" |
*
* @param {General_No_OptionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_no_options = /** @type {((inputs?: General_No_OptionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_No_OptionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_no_options(inputs)
	return de_general_no_options(inputs)
});